import { render, staticRenderFns } from "./DateRangePickerWithPeriods.vue?vue&type=template&id=e2956c52&"
import script from "./DateRangePickerWithPeriods.vue?vue&type=script&lang=js&"
export * from "./DateRangePickerWithPeriods.vue?vue&type=script&lang=js&"
import style0 from "./DateRangePickerWithPeriods.vue?vue&type=style&index=0&id=e2956c52&prod&lang=scss&module=true&"
import style1 from "./DateRangePickerWithPeriods.vue?vue&type=style&index=1&id=e2956c52&prod&lang=scss&"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports